/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ insert: NonNullable<unknown>, update: NonNullable<unknown>, del: NonNullable<unknown> }} Sync_Phase_DiffingInputs */



/**
* | output |
* | --- |
* | "{insert} new, {update} changed, {del} removed" |
*
* @param {Sync_Phase_DiffingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_phase_diffing = /** @type {((inputs: Sync_Phase_DiffingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Phase_DiffingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.insert} neu, ${i?.update} geändert, ${i?.del} entfernt`)
	return /** @type {LocalizedString} */ (`${i?.insert} new, ${i?.update} changed, ${i?.del} removed`)
});